import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { SubmissionDto } from "@services/Api/api.dto";
import { useApiClient } from "@services/Api/ApiClientContext";
import { useSelectedEvent } from "@app/panel/Events/contexts/SelectedEvent.context";
import { useEventsModals } from "@app/panel/Events/contexts/EventsModals.context";

import Portal from "@components/overlay/Portal/Portal";
import Backdrop from "@components/ux/Backdrop/Backdrop";
import Modal from "@components/overlay/Modal/Modal";
import Stack from "@components/arrangement/Stack/Stack";
import Group from "@components/arrangement/Group/Group";
import Button from "@components/dataEntry/Buttons/Button/Button";

import "./SendTicket.scss";

interface SendTicketProps {
  submission: SubmissionDto;
}

const SendTicket = ({ submission }: SendTicketProps) => {
  const [submitting, setSubmitting] = useState<boolean>(false);

  const { event } = useSelectedEvent();
  const { closeModal } = useEventsModals();
  const { sendTickets } = useApiClient();

  const { t } = useTranslation(["eventsModals", "common"]);

  const handleSendTicket = () => {
    if (!submission) return;

    setSubmitting(true);

    sendTickets(event.id, submission.id)
      .then((res) => {
        if (res.status === 204) {
          closeModal();
        }
      })
      .finally(() => setSubmitting(false));
  };

  const descriptionContent = submission.ticketLastSentAt
    ? t("eventsModals:sendTicket.againSendTicketDescription")
    : t("eventsModals:sendTicket.sendTicketDescription");

  return (
    <Portal>
      <Backdrop open>
        <Modal onClose={closeModal}>
          <Stack className="send-ticket-modal">
            <p className="p0 mt-6">{descriptionContent}</p>
            <p className="p0 bold">{submission.email}</p>

            <Group colGap={20} className="mt-5">
              <Button type="submit" variant="primary" onClick={handleSendTicket} disabled={submitting}>
                {t("common:send")}
              </Button>
              <Button variant="secondary" onClick={closeModal}>
                {t("common:cancel")}
              </Button>
            </Group>
          </Stack>
        </Modal>
      </Backdrop>
    </Portal>
  );
};

export default SendTicket;
